module.exports = __webpack_public_path__ + "static/media/F2.9214373f.png";